import { EventData } from 'lib/EventLogger/Event';
import { EventType, Features, SourcePages } from 'lib/EventSchema';

export type EngagementTypes =
  | 'home_tap'
  | 'search_tap'
  | 'saved_searches_tap'
  | 'favorites_tap'
  | 'research_tap'
  | 'more_tap'
  | 'guides_and_reviews_tap'
  | 'news_and_analysis_tap'
  | 'sell_my_car_tap'
  | 'car_values_tap'
  | 'settings_tap'
  | 'back_to_search_tap'
  | 'autolist_icon_tap'
  | 'app_download_tap';

export default class NavBarClick {
  constructor(private sourcePage: SourcePages, private engagementType: EngagementTypes) {}

  eventType = EventType.engagement;

  feature = Features.navBar;

  toJSON(): EventData {
    return {
      event_type: this.eventType,
      feature: this.feature,
      source_page: this.sourcePage,
      engagement_type: this.engagementType,
    };
  }
}
